import Vue from 'vue'
import App from './App.vue'
import router from './router'
import Vant from 'vant'
import 'vant/lib/index.css'
import '@/styles/index.scss' // global css
// import Vconsole from 'vconsole'

import loading from './components/loading/loadingjs'
Vue.use(loading)

Vue.use(Vant)
Vue.config.productionTip = false
// new Vconsole();

new Vue({
  el: '#app',
  router,
  render: (h) => h(App),
}).$mount('#app')

router.beforeEach((to, from, next) => {
  if (to.meta.title) {
    document.title = to.meta.title
  }
  next()
})
